import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  var printMq = '@media print';
  var paragraphContainer = _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: componentTheme.paragraphContainerMargin,
    paddingBottom: componentTheme.paragraphContainerPadding,
    paddingLeft: componentTheme.paragraphContainerPadding,
    backgroundColor: componentTheme.paragraphContainerColor
  }, printMq, {
    display: 'block'
  });
  var fullWidthStyles = {
    flex: 1,
    display: 'flex',
    alignItems: 'center'
  };
  return {
    /* LABELS */

    topLabel: {
      paddingTop: componentTheme.bottomLabelPadding
    },
    bottomLabel: {
      paddingTop: componentTheme.bottomLabelPadding
    },
    /* CHOICES */

    container: props.displayAnswersParagraph ? paragraphContainer : {},
    /* CHOICE */

    choiceContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: componentTheme.choiceContainerMargin
    },
    choiceContainerContent: _objectSpread(_objectSpread({
      padding: componentTheme.choiceContainerContentPadding,
      backgroundColor: componentTheme.choiceContainerContentColor,
      width: '100%'
    }, !props.displayAnswersParagraph && fullWidthStyles), {}, _defineProperty({}, printMq, fullWidthStyles)),
    choicePosition: _defineProperty({
      width: componentTheme.choicePositionWidth,
      textAlign: 'center'
    }, printMq, {
      display: 'none'
    }),
    choice: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: componentTheme.choicePadding,
      border: "".concat(componentTheme.choiceBorder, " solid ").concat(componentTheme.choiceBorderColor),
      borderRadius: componentTheme.choiceBorderRadius,
      backgroundColor: componentTheme.choiceColor
    },
    choiceBody: {
      paddingLeft: componentTheme.choiceBodyPadding,
      paddingRight: componentTheme.choiceBodyPadding
    },
    printedPositionInput: _defineProperty({
      display: 'none'
    }, printMq, {
      display: 'flex',
      marginRight: componentTheme.printedPositionInputMargin
    })
  };
};
export default generateStyle;